export default "__VITE_ASSET__639e5684__"